const services = [
  {
    icon: 'ri-store-2-line',
    title: 'Commercial Build-Outs',
    desc: 'Full interior construction for retail spaces, restaurants, offices, and medical facilities — from framing to final inspection.',
    img: 'https://public.readdy.ai/ai/img_res/07b4d2abb333280db817adb378817525.jpg',
  },
  {
    icon: 'ri-home-office-line',
    title: 'Tenant Improvements',
    desc: 'Tailored upgrades that align with lease agreements, brand standards, and operational goals — on schedule and within budget.',
    img: 'https://readdy.ai/api/search-image?query=modern%20office%20tenant%20improvement%20renovation%2C%20open%20plan%20workspace%20with%20exposed%20ceiling%2C%20polished%20floors%2C%20professional%20commercial%20interior%2C%20warm%20lighting%2C%20architectural%20photography%2C%20clean%20minimal%20aesthetic&width=600&height=400&seq=svc002&orientation=landscape',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Restaurant & Retail Construction',
    desc: 'Health department-compliant kitchen infrastructure, brand-aligned finishes, and timely openings for food service and retail operators.',
    img: 'https://readdy.ai/api/search-image?query=upscale%20restaurant%20interior%20construction%20completed%2C%20warm%20wood%20tones%2C%20pendant%20lighting%2C%20open%20kitchen%20concept%2C%20professional%20commercial%20build-out%2C%20architectural%20photography%2C%20rich%20warm%20tones&width=600&height=400&seq=svc003&orientation=landscape',
  },
  {
    icon: 'ri-hospital-line',
    title: 'Medical & Specialty Facilities',
    desc: 'Precision construction for medical offices and specialty-use spaces with strict compliance, safety systems, and cleanroom standards.',
    img: 'https://readdy.ai/api/search-image?query=modern%20medical%20office%20interior%20construction%20completed%2C%20clean%20white%20walls%2C%20professional%20lighting%2C%20medical%20grade%20flooring%2C%20clinical%20aesthetic%2C%20architectural%20photography%2C%20bright%20and%20clean&width=600&height=400&seq=svc004&orientation=landscape',
  },
  {
    icon: 'ri-building-line',
    title: 'Office & Professional Spaces',
    desc: 'Functional, design-forward office environments built for productivity — from open-plan layouts to executive suites.',
    img: 'https://readdy.ai/api/search-image?query=premium%20modern%20office%20space%20interior%20completed%20construction%2C%20glass%20partitions%2C%20polished%20floors%2C%20professional%20lighting%2C%20executive%20suite%2C%20architectural%20photography%2C%20clean%20minimal%20design&width=600&height=400&seq=svc005&orientation=landscape',
  },
  {
    icon: 'ri-home-gear-line',
    title: 'Commercial Roofing Systems',
    desc: 'Long-term roofing solutions for commercial properties — proper drainage, energy efficiency, and code-compliant installation.',
    img: 'https://readdy.ai/api/search-image?query=commercial%20flat%20roofing%20installation%20on%20large%20building%2C%20professional%20roofers%20working%2C%20wide%20angle%20aerial%20view%2C%20industrial%20roofing%20materials%2C%20professional%20construction%20photography%2C%20warm%20daylight&width=600&height=400&seq=svc006&orientation=landscape',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-amber-600" />
              <span className="text-amber-700 text-xs font-semibold tracking-[0.2em] uppercase">
                What We Build
              </span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Commercial Construction
              <br />
              <span className="text-amber-700">Services in Henry County</span>
            </h2>
          </div>
          <p className="text-stone-500 text-base max-w-sm leading-relaxed">
            Every project is managed end-to-end — permitting, scheduling, trades coordination, and final inspection.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="group bg-stone-50 rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-9 h-9 flex items-center justify-center bg-amber-100 rounded-lg">
                    <i className={`${svc.icon} text-amber-700 text-lg`} />
                  </span>
                  <h3 className="font-bold text-stone-900 text-base">{svc.title}</h3>
                </div>
                <p className="text-stone-500 text-sm leading-relaxed">{svc.desc}</p>
                <div className="mt-4 flex items-center gap-1 text-amber-700 text-sm font-semibold">
                  <span>Learn more</span>
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <a
            href="#contact"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-stone-900 hover:bg-amber-700 text-white font-semibold text-base px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
          >
            Discuss Your Project
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
